/**
 * Created by xiaoconghu on 2018/11/19.
 */
export default {
  local: 'zh_CN',
  table: '表格'
};
